/**
 * sdk 提供需要的接口
 */
import request from './request';
import {BaseUrl, STAFF_SERVICE} from './request.urls';
import queryString from 'query-string';
import {
	EventEmitter
} from 'events';
import * as util from './util';
import * as workTime from './work-time';
workTime.ajustTime();

const sessionId = util.getSessionId();

const Event = new EventEmitter();

// 默认欢迎语
const _welcome = '您好，请简单、清晰的描述问题，小微帮您解决 [愉快]';

// 用户信息
const _sessions = {};
// 机器人 sid
let _robotSid = '';
// 用户 sid
let _accoutSid = '';
// 用户 bid
let _accoutBid = '';
// 人工客服地址
let _staffServiceUrl = '';
// 通道
let _channel = '';
// 来源
let _sourceType = 'cellerPc';

// 消息列表
const _msgList = [];

/**
 * 获取用户信息
 * @param {*} sid
 */
function getSession(sid) {
	return _sessions[sid];
}

/**
 * 获取入口场景值
 * @param {*} sourceType
 */
function getQueueId( sourceType ) {
	const map = {
		buyerApp: 103,
		buyerH5: 102,
		sellerPc: 100,
		sellerApp: 101
	};

	return map[sourceType];
}

/**
 * 获取消息列表
 */
function getMsgList() {
	return _msgList;
}

/**
 * 往 _msgList 添加消息
 * @param {*} msg
 */
function addMsgItem(msg) {
	_msgList.push(msg);
}

/**
 * 推入发送消息
 * @param {*} content
 */
function appendMsg(content) {
	let msg = createMsg(content, _accoutSid, 'send');

	addMsgItem(msg);

	Event.emit('msgChange', msg);
}

function mockRobotSend(content) {
	let msg = createMsg(content, _robotSid, 'receive');
	addMsgItem(msg);
	Event.emit('msgChange', msg);
}

/**
 * 发送消息到服务器
 * @param {*} msg
 * @param {*} fn
 */
function send(msg, fn) {
	if (msg.indexOf('人工') !== -1) {
		let msgR = createMsg('', _robotSid, 'receive');
		msgR.overturn = 1;
		
		addMsgItem(msgR);
		Event.emit('msgChange', msgR);
		return fn(null, {status_code: 0});
	}

	request('sendMessage', {
		bid: _accoutBid,
		question: msg,
		channel: _channel,
		sourceType: _sourceType
	}, (err, response) => {
		if (err) {
			return fn && fn(err, null);
		}

		// _channel
		if (response.status.status_code === 0) {
			fn && fn(null, response.status);

			let msg = createReceiveMsg(response.result);

			addMsgItem(msg);
			Event.emit('msgChange', msg);
		}
	});
}

/**
 * 发送反馈到服务器
 * @param {*} msgId
 * @param {*} feedBackValue
 */
function feedBack(msgId, feedBackValue) {
	request('sendFeedBack', {
		bid: _accoutBid,
		msgId,
		channel: _channel,
		result: feedBackValue,
		sourceType: _sourceType
	}, (err, response) => {
		console.log('feedBack err');
	});
}

function createReceiveMsg(data) {
	let session = getSession(_robotSid);

	// 从无到有时上报渠道
	if (!_channel && window.spider) {
		window.spider.trackAction({
			actionName: "自助客服聊天页-渠道分配",
			actionArgs: {
				"sourceType": _sourceType || 'sellerPC',
				"channel": data.channel,
				sessionId
			}
		});
	}

	_channel = data.channel || _channel;

	let detail = {
		similarQuestion: []
	};

	try {
		detail.similarQuestion = JSON.parse(data.similarQuestion);

		if (!Array.isArray(detail.similarQuestion)) {
			throw data.similarQuestion;
		}
	} catch (error) {
		console.log('相似问题解析出错', data.similarQuestion, error);
	}

	return {
		session,
		detail,
		msgData: data.answer,
		msgId: data.feedbackId,
		time: data.time || +new Date(),
		needFeedback: data.needFeedback,
		overturn: data.overturn,
		role: 'receive',
		isStorage: true
	};
}

function createMsg(msg, sid, role) {
	let session = getSession(sid);

	return {
		session,

		detail: {
			similarQuestion: []
		},

		msgData: msg,
		msgId: Date.now(),
		time: Date.now(),
		needFeedback: 0,
		overturn: 0,
		role,
		isStorage: role !== 'send' //是否入库
	};
}

function onMsgChange(fn) {
	Event.on('msgChange', fn);
}

function ready(robotSid, wduss, sid, bid, fn) {
	let search = queryString.parse(window.location.search);
	
	// 私有变量缓存数据
	_robotSid = robotSid;
	_accoutSid = sid;
	_accoutBid = bid;
	_sourceType = search.sourceType || 'sellerPc';

	if (window.spider) {
		window.spider.trackAction({
			actionName: "自助客服聊天页-进入页面",
			actionArgs: {
				"sourceType": _sourceType || 'sellerPC',
				"channel": _channel,
				sessionId
			}
		});

	}
	getOnlineServerUrl(sid, wduss, bid);
	
	request('getUserInfo', {
		sids: [sid, robotSid].join(','),
		sid,
		bid
	}, (err, response) => {
		if (err) {
			return fn && fn(err, null);
		}

		if (response.status && response.status.status_code === 0) {
			let data = response.result;

			for (let key in data) {
				let info = data[key];

				_sessions[key] = {
					exInfo: info.exInfo,
					portrait: info.headimg, // 头像
					nickname: info.name, // 昵称
					uid: info.uid, // uid
					sid: info.sid, // sid
					userId: info.sid === sid ? bid : info.sid
				};
			}

			// 欢迎语
			let msg = createMsg(_welcome, _robotSid, 'receive');
			// 添加到第一条消息
			addMsgItem(msg);

			fn && fn(null, _sessions);
		} else {
			fn && fn(new Error('请求错误'), null);
		}
	});
}

function gotoStaffService(){
	if (_staffServiceUrl){
		let search = queryString.parse(window.location.search);

		if (!workTime.isSpringWorkTime()) {
			mockRobotSend('【系统消息】2月9日至2月21日春节期间，微店人工在线客服服务时间：09：00-18：00。如需咨询，建议您在工作时间联系客服，感谢您的理解。');
			return;
		}
		if(!workTime.isDouble11WorkTime()){

			mockRobotSend('【系统消息】微店人工在线客服服务时间：09:00-次日2:00。如需咨询，建议您在工作时间联系客服，感谢您的理解。');
			return;
		}
		
		if (!workTime.isSpringFestival() 
				&& !workTime.isDouble11() 
				&& !workTime.isWorkTime()) {
			// 非工作时间点人工
			mockRobotSend('【系统消息】微店人工在线客服服务时间：09:00-21:00。如需咨询，建议您在工作时间联系客服，感谢您的理解。');
			return ;
		}

		if (window.spider) {
			window.spider.trackAction({
				actionName: "自助客服聊天页-人工客服",
				actionArgs: {
					"sourceType": _sourceType || 'sellerPC',
					"channel": _channel,
					sessionId
				}
			});
		}

		window.open(_staffServiceUrl,'_blank');
	}
}

// uid 是传值 bid
function getOnlineServerUrl(userID, wduss, uid, fn) {
	request('getTicket', uid , ( err, {result, status} ) => {
		if ( status && status.status_code === "0" ) {
			let baseUrl = STAFF_SERVICE;
			let search = queryString.parse(window.location.search);
			let queueId = getQueueId(search.sourceType || 'sellerPc'); // 默认卖家 app 兼容老地址

			_staffServiceUrl = `${baseUrl}?ticketuid=${uid}&ticket=${result.ticket}&sellerId=${uid}&queue=${queueId}`;
			console.log(_staffServiceUrl);
		}
	});

	setTimeout(()=> {
		getOnlineServerUrl(userID, wduss, uid);
	}, 4 * 60 * 1000); // 5分钟ticket过期但写成4分钟
}

export default {
	ready,
	getSession,
	getMsgList,
	appendMsg,
	onMsgChange,
	send,
	feedBack,
	getOnlineServerUrl,
	gotoStaffService
};



/** WEBPACK FOOTER **
 ** ./lib/sdk.js
 **/